module.exports = __webpack_public_path__ + "static/media/thumbnail_play_green.08eeadd6.svg";